import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { openToast } from "../../../../Library/ToastPopUp";
import {
  GET_COURSE_VALIDATE_REQ,
  handlePaste,
  handlerRepeatMatch,
  isValidEmailParent,
  TextHandler,
} from "../Components/PCFHandler";
import { REQUEST_TARGET_MODULES } from "../../../../Library/APIsTarget";
import {
  ButtonPrimary,
  InputTextPCF,
  RenderCounselor,
} from "../Components/PCFUI";
import CourseCatalog from "../PCF/FormOvering/CourseCatalog";
import CourseOvering from "../PCF/FormOvering/CourseOvering";
import MYPCF from "./MYPCF";
import { AlertWarning } from "../../Dashboard/Widget/WarningStudyPeriode";

export default function FormRevisiPCF({
  studentid,
  student_status,
  student_bio,
  ref_acad,
  rereg_data,
  setPrevPCF,
}) {
  const selectedAcad = ref_acad?.id;
  const isbachelorReg = student_status.program.id === 1 ? true : false;

  const tmpl_dt = student_status?.tmpl_hd?.tmpl_dt || [];
  const tmpl_max_credit = tmpl_dt.find(item => item.key_id === "key.asc.rereg.pcf.maxcredit")?.value || (isbachelorReg ? 24 : 20);
  const tmpl_check_amount = tmpl_dt.find(item => item.key_id === "key.asc.rereg.pcf.getamount")?.value || "";
  const tmpl_check_amount_new_std =
    tmpl_dt.find((item) => item.key_id === "key.asc.rereg.pcf.newstdgetamount")
      ?.value || "0";

  const [totalsks, setTotalSKS] = useState(0);
  const [maxSKS, setMaxSKS] = useState(tmpl_max_credit ? parseInt(tmpl_max_credit) : (isbachelorReg ? 24 : 20));
  const [mypcf, setMypcf] = useState([]);
  const [mobile, setMobile] = useState({
    phone: "",
    rephone: "",
    match: "",
    message: "",
  });
  const student_addr = student_bio?.reff_address || [];
  const find_email_parents = student_addr && Object.values(student_addr).length > 0
    ? student_addr.find(item => item.email && item.email.trim() !== "")?.email.trim() || ""
    : "";
  const [parent_email, setParentEmail] = useState({
    mail: "",
    message: "",
    match: false,
  });
  const [counselor, setCounselor] = useState({
    loading: false,
    data: [],
    message: "",
  });

  useEffect(() => {
    if (find_email_parents) {
      try {
        setParentEmail({ mail: find_email_parents, message: "", match: true });
      } catch (error) {
        setParentEmail({ mail: "", message: "Error validating email", match: false });
      }
    }
  }, [find_email_parents])

  // useEffect(() => {
  //   if (
  //     student_status &&
  //     student_status.corporate &&
  //     student_status.corporate.id !== 3
  //   ) {
  //     setMaxSKS(totalsks);
  //   }else if(student_status && student_status.program && student_status.program.id === 2){
  //     setMaxSKS(20);
  //   } else {
  //     setMaxSKS(24);
  //   }
  // }, [totalsks]);

  useEffect(() => {
    const fetchCounselor = async () => {
      try {
        if (student_status?.studentid) {
          await GetCounselor(setCounselor, student_status.studentid);
        }
      } catch (error) {
        setCounselor({
          loading: false,
          data: [],
          message: "Failed to load counselor information",
        });
      }
    };

    fetchCounselor();
  }, [student_status?.studentid]);

  useEffect(() => {
    if (Object.values(rereg_data).length > 0) {
      try {
        var arrpcfrev = rereg_data.filter((prev) => prev.in_semester === 1);
        var myPcfrev = GetMyPCFRev(arrpcfrev);
        setMypcf(myPcfrev);
      } catch (error) {
        console.log(error);
        setMypcf([]);
        openToast({ header: "Info", message: "Failed render pcf list" });
      }
    }
  }, [rereg_data]);

  let objparamPCF = {
    cellular: mobile.phone,
    studentid: studentid,
    email: parent_email.mail,
  };

  const handlerRepeat = (value) => {
    const result = handlerRepeatMatch(mobile.phone, value);
    setMobile({ ...mobile, rephone: result.value, match: result.match });
  };

  const current_program_degree = student_status?.program?.id || 0;
  // const current_semester = student_status?.semester || 0;
  const current_cgpa = student_status?.cgpa || 0;
  const minGPABachelor = 2.1;
  const minGPAMaster = 3.1;
  const HandlerMessageThesisWithGPAUnderSpec = (thesis, program) => {
    let message = `You are about to enroll in ${thesis.name} (${thesis.section_id
      }), but your CGPA is below ${program === 1 ? minGPABachelor : program === 2 ? minGPAMaster : ""
      }. This may cause graduation issues since the minimum required CGPA is ${program === 1 ? 2 : program === 2 ? 3 : 0
      }.00. Please consult with your counselor to simulate the minimum GPA you need to achieve this semester.`;

    return message;
  };
  const [has_thesis, setHasThesis] = useState("");

  useEffect(() => {
    if (mypcf) {
      const is_thesis = mypcf.find(
        (item) =>
          item.action_type === "add" &&
          (item.detail.is_thesis !== undefined &&
            item.detail.is_thesis !== null &&
            item.detail.is_thesis !== ""
            ? item.detail.is_thesis === true
            : item.detail.coursetitle.toLowerCase().includes("thesis"))
      );
      if (is_thesis && Object.values(is_thesis).length > 0) {
        const thesis = {
          name: is_thesis?.detail?.coursetitle || "",
          section_id: is_thesis?.section_id || "",
        };
        const message = HandlerMessageThesisWithGPAUnderSpec(
          thesis,
          current_program_degree
        );

        if (
          (current_program_degree === 1 && current_cgpa < minGPABachelor) ||
          (current_program_degree === 2 && current_cgpa < minGPAMaster)
        ) {
          openToast({ header: "Information", message: message });
          setHasThesis(message);
        }
      }
    }
  }, [mypcf]);

  const handlerActionCourse = async (value) => {
    if (value.action_type === "add") {
      if (student_status.term_intake.id === selectedAcad) {
        setMypcf([...mypcf, value]);
      } else {
        try {
          const result = await GET_COURSE_VALIDATE_REQ({
            clu_id: student_status?.clu?.id || 0,
            clu_spec_id: student_status?.clu_spec?.id || 0,
            course_id: value.course_id,
            studentid: studentid.toString(),
          });
          if (result.data === 1) {
            //check existing course
            let isSame = mypcf.filter(
              (prev) =>
                (prev.section_id === value.section_id ||
                  prev.detail.course_code === value.detail.course_code) &&
                (!prev.action_type || prev.action_type !== "remove")
            );
            if (Object.values(isSame).length > 0) {
              const msg = TextHandler.find((item) => item.id === 2);
              openToast({
                header: "Information",
                message: msg.name,
              });
            } else {
              setMypcf([...mypcf, value]);
            }
          } else {
            openToast({
              header: "Information",
              message: "Course is not eligible for selection",
            });
          }
        } catch (error) {
          openToast({
            header: "Error",
            message: "Failed to process course action. Error: " + error?.message,
          });
        }
      }
    } else {
      var clone = [...mypcf];
      clone.splice(value.index, 1);
      setMypcf(clone);
    }
  };

  const [submit, setSubmit] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const handlerSubmitPCF = async (e) => {
    e.preventDefault();

    if (totalsks > maxSKS) {
      openToast({
        header: "Information",
        message: "Maximum total Credit is " + maxSKS + " SKS",
      });
    } else {
      if (Object.values(mypcf).length > 0 && objparamPCF.cellular) {
        if (isbachelorReg) {
          if (!parent_email.match) {
            openToast({
              header: "Information",
              message: "Email parent is empty",
            });
            return;
          }
        }

        const courses = mypcf.map((c) => {
          var obj = {};
          obj.action_type = c.action_type ? c.action_type : "add";
          obj.course_id = c.course_id;
          obj.section_id = c.section_id;
          return obj;
        });

        const paramPost = {
          cellular: objparamPCF.cellular,
          courses: courses,
          studentid: studentid.toString(),
          term_id: ref_acad.id,
          email: parent_email.mail,
        };
        console.log(paramPost);

        setSubmit({ loading: true, message: "", data: [] });

        if (
          (student_status.term_intake.id === selectedAcad && tmpl_check_amount_new_std === "0") ||
          // student_status.enrollment_type_id === "mkt.enrollment.type.cooperation" ||
          // student_status.enrollment_type_id === "mkt.enrollment.type.exchange" ||
          (tmpl_check_amount && tmpl_check_amount === "0")
        ) {
          setSubmit({ loading: false, message: "", data: [] });
          setPrevPCF({
            pcf: mypcf,
            data: [],
            param: paramPost,
            totalsks: totalsks,
            open: true,
          });
          window.scrollTo(0, 0);
        } else {
          const param_amount = {
            parameters: paramPost,
            target_data: "GET_PCF_AMOUNT",
          };

          const results = await REQUEST_TARGET_MODULES(param_amount);
          if (results.data && Object.values(results.data).length > 0) {
            setSubmit({ loading: false, message: "", data: results.data });
            setPrevPCF({
              pcf: mypcf,
              data: results.data,
              open: true,
              param: paramPost,
              totalsks: totalsks,
            });
            window.scrollTo(0, 0);
          } else {
            openToast({ header: "Info", message: results.message });
            setSubmit(results);
          }
        }
      } else {
        const msg = TextHandler.find((item) => item.id === 1);
        openToast({
          header: "Information",
          message: msg.name,
        });
      }
    }
  };
  return (
    <div id="form-pcf-first">
      <div className="row">
        <div className="col-lg-4">
          <CourseOvering
            data={rereg_data}
            handlerActionCourse={handlerActionCourse}
          />
        </div>
        <div className="col-lg-4">
          {selectedAcad && (
            <CourseCatalog
              handlerActionCourse={handlerActionCourse}
              student={student_status}
              selectedAcad={selectedAcad}
            />
          )}
        </div>
        <div className="col-lg-4">
          <MYPCF
            maxSKS={maxSKS}
            mypcf={mypcf}
            setMypcf={setMypcf}
            totalsks={totalsks}
            setTotalSKS={setTotalSKS}
            handlerActionCourse={handlerActionCourse}
          />
        </div>
      </div>

      {has_thesis && (
        <AlertWarning title={"CGPA Warning"} message={has_thesis} />
      )}

      <div className="card card-custom gutter-b">
        <div className="card-body">
          <form
            method="post"
            autoComplete="off"
            onSubmit={(e) => handlerSubmitPCF(e)}
          >
            <div className={`row justify-content-${isbachelorReg ? 'between' : 'center'} align-items-start`}>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-lg-6">
                    <InputTextPCF
                      title={"Student WhatsApp Number"}
                      required={true}
                      msgerror={
                        (!mobile.phone && "Fill up this field") || mobile.message
                      }
                      value={mobile.phone}
                      name="phone"
                      minLength={10}
                      className={
                        "form-control " +
                        (Object.values(mobile.phone).length > 10
                          ? "is-valid"
                          : "is-invalid")
                      }
                      placeholder="081xxx"
                      onChange={(e) =>
                        setMobile({
                          ...mobile,
                          phone: e.target.value.replace(/\D/g, ""),
                        })
                      }
                    />
                  </div>
                  <div className="col-lg-6">
                    <InputTextPCF
                      title={"Confirm Student WhatsApp Number"}
                      required={true}
                      msgerror={mobile.message}
                      onPaste={handlePaste}
                      minLength={10}
                      name="repeat-phone"
                      placeholder="081xxx"
                      className={
                        "form-control " +
                        (mobile.match === "match" ? "is-valid" : "is-invalid")
                      }
                      onChange={(e) =>
                        handlerRepeat(e.target.value.replace(/\D/g, ""))
                      }
                      value={mobile.rephone}
                    />
                  </div>
                </div>
              </div>
              {isbachelorReg && (
                <div className="col-lg-3">
                  <InputTextPCF
                    title={"Parent Email Address (for billing purposes)"}
                    required={true}
                    msgerror={
                      (!parent_email.mail && "Fill up this field") ||
                      parent_email.message
                    }
                    className={
                      "form-control " +
                      (!parent_email.match ? "is-invalid" : "is-valid")
                    }
                    onChange={(e) =>
                      setParentEmail(isValidEmailParent(e.target.value))
                    }
                    value={parent_email.mail}
                  />
                </div>
              )}

              {Object.values(counselor.data).length > 0 && (
                <RenderCounselor counselor={counselor} />
              )}
            </div>

            <div className="text-center">
              <Link className="btn btn-light font-weight-bolder text-uppercase px-9 py-4 mr-5" to={"/registration/plan-course-form"}>
                Cancel
              </Link>
              <ButtonPrimary
                type="submit"
                className="font-weight-bolder text-uppercase px-9 py-4 btn-submit"
                disabled={
                  submit.loading
                    ? submit.loading
                    : mobile.rephone
                      ? mobile.phone === mobile.rephone
                        ? false
                        : true
                      : true
                }
              >
                {submit.loading ? "Processing" : "Next and Preview"}
              </ButtonPrimary>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const GetCounselor = async (setCounselor, studentid) => {
  setCounselor({ loading: true, data: [], message: "" });
  const param = {
    parameters: {
      studentid: studentid,
    },
    target_data: "GET_COUNSELOR",
  };
  const results = await REQUEST_TARGET_MODULES(param);
  if (results.data && Object.values(results.data).length > 0) {
    setCounselor(results);
  } else {
    setCounselor({
      loading: false,
      data: [],
      message: "You do not have a counselor.",
    });
  }
};

const GetMyPCFRev = (arrData) => {
  console.log(arrData);
  var computedData = arrData.map((v) => {
    var obj = {};
    var detail = {};
    obj.course_id = v.course_id;
    obj.section_id = v.section_id;
    obj.origin = true;
    obj.action_type = "add";
    detail.coursetitle = v.coursetitle;
    detail.course_id = v.course_id;
    detail.course_code = v.code;
    detail.course_credit = v.credit;
    detail.is_thesis = v?.is_thesis || "";
    detail.section_id = v.section_id ? v.section_id : "-";
    detail.not_billed = v.not_billed;
    obj.detail = detail;
    return obj;
  });
  return computedData;
};
